document.addEventListener("DOMContentLoaded", async () => {
    const inputs = document.querySelectorAll(".filters__search input");
    const filterInputs = document.querySelectorAll(".filters__sort input");
    const filtersSort = document.querySelector(".filters__sort");
    const form = document.querySelector(".filters__form");
    const clearButton = form?.querySelector(".filters__clear");

    if (!inputs.length) return;

    const response = await fetch("/wp-json/custom/v1/exhibitor-titles");
    const postTitles = await response.json();

    const updateClearButton = () => {
        if (!clearButton) return;

        const form = clearButton.closest("form");
        if (!form) return;

        const hasValue = Array.from(form.querySelectorAll("input")).some(i => {
            if (["text", "search", "number", "email", "tel", "url", "password"].includes(i.type)) {
                return i.value.trim() !== "";
            }
            if (["checkbox", "radio"].includes(i.type)) {
                return i.checked;
            }
            return false;
        });

        clearButton.style.display = (hasValue) ? "flex" : "none";
    };

    for (const input of inputs) {
        const list = input.parentElement.querySelector(".filters__search-results");

        const hideList = () => {
            if (list) list.style.display = "none";
        };

        const showList = () => {
            if (list) list.style.display = "block";
        };


        hideList();
        updateClearButton();

        input.addEventListener("input", (e) => {
            updateClearButton();

            if (list) list.innerHTML = "";

            if (e.target.value.length < 3) {
                hideList();
                return;
            }

            const searchWords = e.target.value.toLowerCase().trim().split(" ").filter(Boolean);

            const allWordsMatch = postTitles.filter(title => {
                const titleWords = title.toLowerCase().trim().split(" ");
                return searchWords.every(searchWord =>
                    titleWords.some(titleWord => titleWord.includes(searchWord))
                );
            });

            if (allWordsMatch.length) {
                allWordsMatch.forEach(title => {
                    const li = document.createElement("li");
                    li.textContent = title;
                    li.addEventListener("click", () => {
                        input.value = title;
                        hideList();
                        updateClearButton();

                        input.dispatchEvent(new Event('input', { bubbles: true }));
                        if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                    });
                    list.appendChild(li);
                });
                showList();
            } else {
                hideList();
            }
        });

        input.addEventListener("focus", () => {
            if (list && list.children.length) showList();
        });

        document.addEventListener("click", (e) => {
            if (!input.contains(e.target) && !list.contains(e.target)) {
                hideList();
            }
        });

        clearButton?.addEventListener("click", () => {
            const form = clearButton.closest("form");
            if (!form) return;

            const formInputs = form.querySelectorAll("input");
            formInputs.forEach(i => {
                if (["text", "search", "number", "email", "tel", "url", "password"].includes(i.type)) {
                    i.value = "";
                }
            });

            const lists = form.querySelectorAll(".filters__search-results");
            lists.forEach(l => l.style.display = "none");

            if (clearButton) clearButton.style.display = "none";

            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));

            const url = window.location.origin + window.location.pathname;
            window.history.replaceState({}, document.title, url);
        });

    }

    filterInputs.forEach(input => input.addEventListener("change", () => {
        updateClearButton();
        closeFilterList();
    }));

    const closeOutSideFilterList = (e) => { if (!filtersSort.contains(e.target)) closeFilterList(); }

    function closeFilterList() {
        filtersSort.classList.remove("active");
        document.removeEventListener("click", closeOutSideFilterList);
    }

    filtersSort.querySelector("button").addEventListener("click", () => {
        if ( filtersSort.classList.contains("active") ) {
            closeFilterList();
        }
        else {
            filtersSort.classList.add("active");
            document.addEventListener("click", closeOutSideFilterList);
        }
    });
});
